/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React from 'react';

export type StatusComponentProp = {
    status:string
}

const StatusComponent = ({ status }:StatusComponentProp) => (
<>
{status === 'success' ? (
              <div id="succ" className="alert alert-success text-center" style={{ display: 'block' }} role="alert">cloud successfully authorized</div>
) : status === 'fail' ? (
            <div className="alert alert-danger text-center" id="fail" style={{ display: 'block' }} role="alert">There was an error authorizing the cloud account</div>
) : ''}
</>
);

export default StatusComponent;